import { ICdInsert, ICdInsertPayload } from "../types/easy-e-m-i-loan-journey-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export const cdInsert = async (payload: ICdInsertPayload): Promise<IResponse<ICdInsert>> => {
  const response = await encryptedRequest<ICdInsert>({
    method: "POST",
    url: `${API_PATHS.cdInsert}`,
    data: payload,
  });
  return response;
};
